import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { ApplicationState } from "../redux/ApplicationState";
import { ScorecardBaselineTableDispatchTypes, ScorecardDetailsDispatchTypes } from "../models/dispatchTypes/Scorecard";
import { GetScorecardBaselineTableActionDispatchTypes, GetScorecardDetailsActionDispatchTypes } from "../constants/Scorecard";
import { GetScorecardBaselineTable, GetScorecardDetails } from "../services/Scorecard";
import { configUrl } from "../constants/Config";
import { MessageType, ResponseMessages } from "../constants/ResponseMessage";
import toastType from "../utils/SnackbarProvider";
import { QuarterRange } from "../models/Scorecard";

export const getScorecardDetails: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ScorecardDetailsDispatchTypes
  >
> = ( providerNpi: string, quarterRange: QuarterRange , performancePeriod?:string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetScorecardDetailsActionDispatchTypes.GET_SCORECARD_DETAILS_INVOKE,
    });
    const response = await GetScorecardDetails(configUrl, providerNpi, quarterRange);

    if (response && response.status) {
      switch (response.status) {
        case 500:
        case 502:
        case 503:
          toastType.error(ResponseMessages(MessageType.SCORECARD_DETAILS_TECHNICAL_DIFFICULTIES_ERROR));
          break;
        case 422:
        case 400:
        case 404:
          dispatch({
            error: response,
            response: null,
            type: GetScorecardDetailsActionDispatchTypes.GET_SCORECARD_DETAILS_ERROR,
          });
          toastType.error(ResponseMessages(MessageType.SCORECARD_DETAILS_NOT_FOUND_ERROR, performancePeriod));
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetScorecardDetailsActionDispatchTypes.GET_SCORECARD_DETAILS_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};

export const getScorecardBaselineTable: ActionCreator<
  ThunkAction<
    void,
    ApplicationState,
    Record<string, never>,
    ScorecardBaselineTableDispatchTypes
  >
> = ( providerState: string, quarterRange: QuarterRange, pcmNpi: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: GetScorecardBaselineTableActionDispatchTypes.GET_SCORECARD_BASELINE_TABLE_INVOKE,
    });
    const response = await GetScorecardBaselineTable(configUrl, providerState, quarterRange, pcmNpi);

    if (response && response.status) {
      switch (response.status) {
        case 500:
        case 502:
        case 503:
        case 422:
        case 400:
        case 404:
          dispatch({
            error: response,
            response: null,
            type: GetScorecardBaselineTableActionDispatchTypes.GET_SCORECARD_BASELINE_TABLE_ERROR,
          });
          break;
        case 200:
        case 201:
          dispatch({
            response: response.data,
            type: GetScorecardBaselineTableActionDispatchTypes.GET_SCORECARD_BASELINE_TABLE_SUCCESS,
          });
          break;
        default:
          break;
      }
    }
  };
};